import React, { Component } from 'react';
import { SearchRequest, SearchResponse } from '../../rpc/admin/search_pb';
import Adapter from './adapter';

interface StringFacetProps {
    adapter: Adapter;
    field: string ;
    value: SearchResponse.Aggregation.String;
}

interface StringFacetState { }

class StringFacet extends Component<StringFacetProps, StringFacetState> {

    toggle = () => {
        const filter = new SearchRequest.Filter()
        filter.setField(this.props.field);
        const sf = new SearchRequest.Filter.String();
        sf.setValue(this.props.value.getValue());
        filter.setStringFilter(sf);
        if (this.props.value!.getChecked()) {
            this.props.adapter.removeFilter(filter);
        } else {
            this.props.adapter.addFilter(filter);
        }
    }

    render() {
        return (
            <div className="search-facet">
                <label className="checkbox">
                    <input type="checkbox" checked={this.props.value!.getChecked()} onChange={this.toggle} />
                    <span className="search-facet-label">{this.props.value!.getValue()}</span>
                </label>
                <div className="search-facet-count">{this.props.value!.getCount()}</div>
            </div>
        );
    }
}

export default StringFacet;
